import { render, staticRenderFns } from "./tele-health.vue?vue&type=template&id=4c8b6475&scoped=true&"
import script from "./tele-health.vue?vue&type=script&lang=js&"
export * from "./tele-health.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./tele-health.vue?vue&type=style&index=1&id=4c8b6475&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b6475",
  null
  
)

component.options.__file = "tele-health.vue"
export default component.exports